import {Toast} from "antd-mobile";
import './Toast.scss';

export const centerToast = (text) => {
    Toast.show({
        content: text,
        position: 'center',
        duration: 2500,
    })
}